export default defineNuxtRouteMiddleware(async (to) => {
  if (!import.meta.client || !to.path.startsWith('/account')) return
  const { restore, authorizationHeader } = useMemberAuth()
  restore()
  if (!authorizationHeader()) {
    return navigateTo({ path: '/login', query: { redirect: to.fullPath } })
  }
})
